import { withNamespaces } from "react-i18next";
import { Badge } from "reactstrap";

import "../AssessmentGapNotice/style.scss";
import "./style.scss";

/**
 * Risk condition notice for the privacy Risk Assessment questionnaire.
 * Same palette as assessment gaps; copy and layout reflect identified DPIA risks.
 *
 * @param {Object} props
 * @param {Object} props.gap
 * @param {Function} props.t
 */
const AssessmentRiskConditionNotice = ({ gap, t }) => {
    if (!gap) {
        return null;
    }

    const title = typeof gap.title === "string" ? gap.title.trim() : "";
    const description = typeof gap.description === "string"
        ? gap.description.trim()
        : "";

    return (
        <div
            className="assessment-gap-notice assessment-risk-condition-notice"
            role="status"
        >
            <div className="assessment-risk-condition-notice__layout">
                <div
                    className="assessment-risk-condition-notice__icon"
                    aria-hidden="true"
                >
                    <i className="ri-alert-line" />
                </div>

                <div className="assessment-risk-condition-notice__content">
                    <div className="assessment-gap-notice__badges">
                        <Badge className="assessment-risk-condition-notice__badge">
                            {t("Risk Identified")}
                        </Badge>
                    </div>

                    {title && (
                        <div className="assessment-gap-notice__title">
                            {title}
                        </div>
                    )}

                    {description && (
                        <div className="assessment-gap-notice__description">
                            {description}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default withNamespaces()(AssessmentRiskConditionNotice);
